<template>
    <div class='component-page'>
        <!--文本搜索位置-->
        <div class="filter-area">
            <Row style='text-align: center;' class='add_search'>
                <Col span="4">
                    <Input search v-model="formItem.proxy_name" placeholder="输入代理人名称" @on-search="handleSearch" style="width:100%;" />
                </Col>
               
                <Col span="2" style='float:right'>
                <i-button icon="md-add" shape="circle" type="primary" @click="add_new">添加</i-button>
                </Col>
            </Row>
        </div>
        <!--下拉搜索位置-->
        <div class="edittable-table-height-con">
            <Row style='margin:10px 0'>
                <Col span="20">
                        <Select v-model="formItem.province_id" placeholder="请选择" @on-change="changeProvince" label-in-value clearable style="width:200px">
                            <Option v-for="item in provinceList" :value="item.province_id" :key="item.province_id">{{ item.province_name }}</Option>
                        </Select>
                        <Select ref='citySelects' v-model="formItem.city_id" placeholder="请选择" @on-change="changeCity" label-in-value clearable style="width:200px;margin:0 10px;">
                            <Option v-for="item in cityList" :value="item.city_id" :key="item.city_id">{{ item.city_name }}</Option>
                        </Select>
                        <Select ref='areaSelects' v-model="formItem.area_id" placeholder="请选择" @on-change="changeArea" label-in-value clearable style="width:200px">
                            <Option v-for="item in areaList" :value="item.area_id" :key="item.area_id">{{ item.area_name }}</Option>
                        </Select>
                </Col>
            </Row>
            <Table stripe border :columns="editIncellColumns" :data="editIncellData"></Table>
            <div style="margin: 20px 0 10px 0 ;overflow: hidden;">
                <Page style='float: right'  size="small" :total="total_count" :page-size="formItem.page_size" :current="formItem.page" @on-change="changePage" />
            </div>
        </div>
        <Modal v-model="addModel" width="800" title="新增">
            <div v-if='addModel'>
                <Form ref="formData" :model="formData" :rules="verificationRule" label-position="top">
                    <Row>
                        <Col span="11">
                          <FormItem label="负责人名称" prop='proxy_name'>
                              <Input v-model="formData.proxy_name" placeholder="请输入..."></Input>
                          </FormItem>
                        </Col>
                        <Col span="11" offset="2">
                          <FormItem label="城市合伙人公司名称" prop='company_name'>
                              <Input v-model="formData.company_name" placeholder="请输入..."></Input>
                          </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <Col span="20">
                            <FormItem label="所在省市" prop='province_id'>
                                <Select v-model="formData.province_id" placeholder="请选择" @on-change="changeProvince" label-in-value clearable style="width:200px">
                                    <Option v-for="item in provinceList" :value="item.province_id" :key="item.province_id">{{ item.province_name }}</Option>
                                </Select>
                                <Select ref='citySelect' v-model="formData.city_id" placeholder="请选择" @on-change="changeCity" label-in-value clearable style="width:200px;margin:0 10px;">
                                    <Option v-for="item in cityList" :value="item.city_id" :key="item.city_id">{{ item.city_name }}</Option>
                                </Select>
                                <Select ref='areaSelect' v-model="formData.area_id" placeholder="请选择" @on-change="changeArea" label-in-value clearable style="width:200px">
                                    <Option v-for="item in areaList" :value="item.area_id" :key="item.area_id">{{ item.area_name }}</Option>
                                </Select>
                            </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <Col span="11">
                            <FormItem label="详细地址" prop='address'>
                                <Input v-model="formData.address" placeholder="请输入..."></Input>
                            </FormItem>
                        </Col>
                        <Col span="11" offset="2">
                            <FormItem label="授权区域" prop='auth_area'>
                                <Input v-model="formData.auth_area" placeholder="请输入..."></Input>
                            </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <Col span="11">
                            <FormItem label="手机号码" prop='phone'>
                                <Input v-model="formData.phone" placeholder="请输入..."></Input>
                            </FormItem>
                        </Col>
                        <Col span="11" offset="2">
                            <FormItem label="邮箱" prop='email'>
                                <Input v-model="formData.email" placeholder="请输入..."></Input>
                            </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <Col span="11">
                            <FormItem label="登录账号（登录账号为手机号）" prop='username'>
                                <Input v-model="formData.username" placeholder="登录账号为手机号"></Input>
                            </FormItem>
                        </Col>
                        <Col span="11" offset="2">
                            <FormItem label="登录密码" prop='password'>
                                <Input v-model="formData.password" placeholder="请输入..."></Input>
                            </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <Col span="11">
                            <FormItem label="保证金" prop='caution_money'>
                                <Input v-model="formData.caution_money" placeholder="请输入..."></Input>
                            </FormItem>
                        </Col>
                        <Col span="11" offset="2">
                            <FormItem label="合同年限" prop='teamwork_time'>
                                <Input v-model="formData.teamwork_time" placeholder="请输入..."></Input>
                            </FormItem>
                        </Col>
                    </Row>
                    <FormItem label="上传公司资质" prop='file_url'>
                        <UploadImg @getPicList="getPicList" v-if='addModel' :getList='formData.file_url' message='100' id='cover'></UploadImg>
                    </FormItem>
                    <Row>
                        <Col span="11">
                            <FormItem label="机构属性" prop='agency_attr'>
                                <Input v-model="formData.agency_attr" placeholder="请输入..."></Input>
                            </FormItem>
                        </Col>
                        <Col span="11" offset="2">
                            <FormItem label="备注" prop='remark'>
                                <Input v-model="formData.remark" type='textarea' placeholder="请输入..."></Input>
                            </FormItem>
                        </Col>
                    </Row>
                </Form>
            </div>
            <div slot="footer">
                <Button type='primary' shape="circle"  ghost @click='cancel'>取消</Button>
                <Button type="primary" shape="circle"  @click="save('formData')">确定</Button>
            </div>
        </Modal>
        <!--提醒弹层-->
        <Modal v-model="remindModal" width="440" class='remind'>
            <div class='remindContent'>
                {{remindContent}}
            </div>
            <div slot="footer">
                <Button type='primary' ghost shape="circle" @click='cancelRemain'>取消</Button>
                <Button type="primary" shape="circle" @click="primaryRemind">确定</Button>
            </div>
        </Modal>
        <Modal v-model="schoolModel" width="720" title="查看校区">
            <Table stripe border :columns="schoolColumns" :data="schoolData"></Table> 
            <div slot="footer">
                <Button type='primary' shape="circle" ghost @click='cancel'>关闭</Button>
            </div>      
        </Modal>
    </div>
</template>

<style lang="css">
    @import "../common.css";
</style>
<script>
    import {
        fetchTableList,
        fetchInfo,
        addModify,
        setDel,
        fetchSchoolList,
        setStatus
    } from '@/api/agentList'
    import {
        fetchProvinceList,
        fetchCityList,
        fetchAreaList,

    } from '@/api/common'
    import UploadImg from '../common/picture.vue'

    export default {
        name: 'user-components',
        components: {
            UploadImg,
        },
        data () {
            return {
                total_count: 0, //列表总条数
                formItem:{
                    page: 1, //列表当前页数
                    page_size: 10,
                    proxy_name: '', 
                    province_id:'',
                    city_id:'',
                    area_id:'',
                },
                schoolModel:false,//查看校区弹出状态
                addModel:false,//添加修改弹出层状态
                remindContent:'',//提醒内容
                remindModal:false,//提醒弹层状态
                formData:{
                    proxy_id:'',
                    proxy_name:'',
                    company_name:'',
                    province_id	:'',
                    province_name:'',
                    city_id:'',
                    city_name:'',
                    area_id:'',
                    area_name:'',
                    address:'',
                    auth_area:'',
                    phone:'',
                    username:'',
                    password:'',
                    email:'',
                    caution_money:'',
                    teamwork_time:'',
                    agency_attr:'',
                    file_url:'',
                    remark:'',

                },//添加修改的表单数据
                proxy_id:'',
                verificationRule:{
                    username: [
                        { required: true, message: '登录账号不能为空'}
                    ],
                    password: [
                        { required: true, message: '密码不能为空'}
                    ],
                    proxy_name: [
                        { required: true, message: '负责人名称不能为空'}
                    ],
                    company_name: [
                        { required: true, message: '公司名称不能为空'}
                    ],
                    province_id: [
                        { required: true, message: '所在省市不能为空'}
                    ],
                    address: [
                        { required: true, message: '详细地址不能为空'}
                    ],
                    auth_area: [
                        { required: true, message: '授权区域不能为空'}
                    ],
                    phone: [
                        { required: true, message: '手机号码不能为空'}
                    ],
                    usernaem: [
                        { required: true, message: '账号不能为空'}
                    ],
                    email: [
                        { required: true, message: '邮箱不能为空'}
                    ],
                    caution_money: [
                        { required: true, message: '保证金不能为空'}
                    ],
                    teamwork_time: [
                        { required: true, message: '合同年限不能为空'}
                    ],
                    // agency_attr: [
                    //     { required: true, message: '机构属性不能为空'}
                    // ],
                    file_url: [
                        { required: true}
                    ],
                    file_url: [
                        { required: true}
                    ],
                    

                },//添加修改的表单验证规则
                schoolColumns:[
                    {
                        title: '序号',
                        align: 'center',
                        type: 'index',
                        width: 80,
                    },
                    {
                        title: '学校名称',
                        align: 'center',
                        key: 'school_name',

                    },
                    {
                        title: '学员人数',
                        align: 'center',
                        key: 'student_num',
                    },

                ],
                schoolData:[],
                provinceList:[],
                cityList:[],
                areaList:[],
                editIncellColumns: [
                    {
                        title: '序号',
                        align: 'center',
                        type: 'index',
                        width: 80,
                    },
                
                    {
                        title: '代理人名称',
                        align: 'center',
                        key: 'proxy_name',

                    },
                    {
                        title: '所在城市',
                        align: 'center',
                        key: 'city_name',
                    },
                    {
                        title: '手机号',
                        align: 'center',
                        key: 'phone',
                        
                    },
                    {
                        title: '邮箱',
                        align: 'center',
                        key: 'email',
                    },
                    {
                        title: '状态',
                        align: 'center',
                        key: 'status',
                        render: (h, params) => {
                            if(params.row.status==1){
                                return h('span', '正常')
                            }else{
                                return h('span', '禁用')
                            }
                        }
                    },
                    {
                        title: '校区',
                        align: 'center',
                        key: 'school_name',
                        render: (h, params) => {
                            
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'primary',
                                        size: 'small',
                                        ghost: true
                                    },
                                    on: {
                                        click: () => {
                                            this.seeSchool(params.row.proxy_id)
                                        }
                                    }
                                }, '查看'),
                            ])
                        }
                    },
                    {
                        title: '创建时间',
                        align: 'center',
                        key: 'create_at',
                        width: 150,
                    },
                    {
                        title: '操作',
                        align: 'center',
                        key: 'action',
                        width: 200,
                        render: (h, params) => {
                            if(params.row.status==1){
                                return h('div', [
                                    h('Button', {
                                        props: {
                                            type: 'info',
                                            size: 'small',
                                            ghost: true

                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.edit(params.row.proxy_id)
                                            }
                                        }
                                    }, '修改'),
                                    h('Button', {
                                        props: {
                                            type: 'error',
                                            size: 'small',
                                            ghost: true
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.delete(params.row.proxy_id)
                                            }
                                        }
                                    }, '删除'),
                                    h('Button', {
                                        props: {
                                            type: 'error',
                                            size: 'small',
                                            ghost: true
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.changeStatus(params.row.proxy_id,'确定封禁该代理吗？')
                                            }
                                        }
                                    }, '封禁'),
                                ])
                            }else{
                                return h('div', [
                                    h('Button', {
                                        props: {
                                            type: 'info',
                                            size: 'small',
                                            ghost: true

                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.edit(params.row.proxy_id)
                                            }
                                        }
                                    }, '修改'),
                                    h('Button', {
                                        props: {
                                            type: 'error',
                                            size: 'small',
                                            ghost: true
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.delete(params.row.proxy_id)
                                            }
                                        }
                                    }, '删除'),
                                    h('Button', {
                                        props: {
                                            type: 'primary',
                                            size: 'small',
                                            ghost: true
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.changeStatus(params.row.proxy_id,'确定解封该代理吗？')
                                            }
                                        }
                                    }, '解封'),
                                ])
                            }
                           
                        }
                    }
                
                ],//列表
                editIncellData: [],//列表数据
            };
        },
        methods: {
            //获取列表数据
            getData () {
                this.$Loading.start();
                fetchTableList(this.formItem).then(res => {
                    res=res.data;
                    this.$Loading.finish();
                    if(res.code == 200){
                        this.editIncellData = res.data.list;
                        this.total_count = parseInt(res.data.total_count);
                    }else if(res.code == 14001){
                        this.$Message.error(res.msg);
                        this.$store.dispatch('handleLogOut').then(res => {
                            this.$store.commit('clearOpenedSubmenu')
                            this.$router.push({
                                name: 'login'
                            })
                        })
                    }else{
                        this.$Message.error(res.msg);
                    }
                })
            },
            seeSchool(id){
                fetchSchoolList({
                    proxy_id:id
                }).then(res => {
                    res = res.data;
                    if (res.code == 200) {
                        if(res.data.length){
                            this.schoolData = res.data;
                        }else{
                            this.schoolData = [];
                        }
                        this.schoolModel = true;
                    } else if (res.code == 14001) {
                        this.$Message.error(res.msg)
                        this.$store.dispatch('handleLogOut').then(res => {
                            this.$store.commit('clearOpenedSubmenu')
                            this.$router.push({
                                name: 'login'
                            })
                        })
                    } else {
                        this.$Message.error(res.msg)
                    }
                })
            },
            // 添加
            add_new(){
                this.verificationRule.password[0].required=true;

                this.formData.proxy_id='';
                this.formData.proxy_name='';
                this.formData.company_name='';
                this.formData.province_id='';
                this.formData.province_name='';
                this.formData.city_id='';
                this.formData.city_name='';
                this.formData.area_id='';
                this.formData.area_name='';
                this.formData.address='';
                this.formData.auth_area='';
                this.formData.phone='';
                this.formData.username='';
                this.formData.password='';
                this.formData.email='';
                this.formData.caution_money='';
                this.formData.teamwork_time='';
                this.formData.agency_attr='';
                this.formData.file_url='';
                this.formData.remark='';

                this.addModel=true;
            },
            // 修改获取详情
            edit(id){
                this.verificationRule.password[0].required=false;
                
                fetchInfo({
                    proxy_id:id
                }).then(res => {
                    res = res.data;
                    if (res.code == 200) {
                        this.formData=res.data;
                        this.formData.province_id = parseInt(this.formData.province_id);
                        this.getCityList(this.formData.province_id);
                        this.getAreaList(this.formData.city_id)
                        this.formData.city_id = parseInt(this.formData.city_id);
                        this.formData.area_id = parseInt(this.formData.area_id);
                      
                        this.addModel=true;
                    } else if (res.code == 14001) {
                        this.$Message.error(res.msg)
                        this.$store.dispatch('handleLogOut').then(res => {
                            this.$store.commit('clearOpenedSubmenu')
                            this.$router.push({
                                name: 'login'
                            })
                        })
                    } else {
                        this.$Message.error(res.msg)
                    }
                })
            },
            // 保存新增和修改
            save(name){
                this.$refs[name].validate(valid => {
                    if (valid) {
                        addModify(this.formData).then(res => {
                            res = res.data;
                            if (res.code == 200) {
                                this.getData();

                                this.addModel=false;
                            } else if (res.code == 14001) {
                            this.$Message.error(res.msg)
                            this.$store.dispatch('handleLogOut').then(res => {
                                this.$store.commit('clearOpenedSubmenu')
                                this.$router.push({
                                name: 'login'
                                })
                            })
                            } else {
                            this.$Message.error(res.msg)
                            }
                        })
                    
                    }
                })
            },

            // 删除
            delete(id) {
                this.proxy_id = id;
                this.remindContent = '确定删除该代理人吗？';
                this.remindModal = true; 
            },
            // 改变状态
            changeStatus(id,info){
                this.proxy_id = id;
                this.remindContent = info;
                this.remindModal = true; 
            },
            //提醒弹出层的确定事件
            primaryRemind(){
                if(this.remindContent == '确定删除该代理人吗？'){
                    setDel({
                        proxy_id:this.proxy_id
                    }).then(res => {
                        res=res.data;
                        if(res.code==200){
                            this.getData();
                            this.remindModal=false;
                        }else if(res.code == 14001){
                            this.$Message.error(res.msg);
                            this.$store.dispatch('handleLogOut').then(res => {
                                this.$store.commit('clearOpenedSubmenu')
                                this.$router.push({
                                    name: 'login'
                                })
                            })
                        }else{
                            this.$Message.error(res.msg);
                        }
                    })
                }else{
                    setStatus({
                        proxy_id:this.proxy_id
                    }).then(res => {
                        res=res.data;
                        if(res.code==200){
                            this.getData();
                            this.remindModal=false;
                        }else if(res.code == 14001){
                            this.$Message.error(res.msg);
                            this.$store.dispatch('handleLogOut').then(res => {
                                this.$store.commit('clearOpenedSubmenu')
                                this.$router.push({
                                    name: 'login'
                                })
                            })
                        }else{
                            this.$Message.error(res.msg);
                        }
                    })
                }
                
            },
            getProvinceList(){
                fetchProvinceList().then(res => {
                        res=res.data;
                        if(res.code==200){
                            this.provinceList=res.data;
                        }else if(res.code == 14001){
                            this.$Message.error(res.msg);
                            this.$store.dispatch('handleLogOut').then(res => {
                                this.$store.commit('clearOpenedSubmenu')
                                this.$router.push({
                                    name: 'login'
                                })
                            })
                        }else{
                            this.$Message.error(res.msg);
                        }
                    })

            },
            
            getCityList(id){
                fetchCityList({
                    province_id:id
                }).then(res => {
                        res=res.data;
                        if(res.code==200){
                            this.cityList=res.data;
                        }else if(res.code == 14001){
                            this.$Message.error(res.msg);
                            this.$store.dispatch('handleLogOut').then(res => {
                                this.$store.commit('clearOpenedSubmenu')
                                this.$router.push({
                                    name: 'login'
                                })
                            })
                        }else{
                            this.$Message.error(res.msg);
                        }
                    })

            },
            getAreaList(id){
                fetchAreaList({
                    city_id:id
                }).then(res => {
                        res=res.data;
                        if(res.code==200){
                            this.areaList=res.data;
                        }else if(res.code == 14001){
                            this.$Message.error(res.msg);
                            this.$store.dispatch('handleLogOut').then(res => {
                                this.$store.commit('clearOpenedSubmenu')
                                this.$router.push({
                                    name: 'login'
                                })
                            })
                        }else{
                            this.$Message.error(res.msg);
                        }
                    })

            },
            getPicList(picList) {
                var arr = [];
                for (var i = 0; i < picList.length; i++) {
                    arr.push(picList[i].url.split('.com')[1])
                }
                this.formData.file_url = arr;
            },
            changeProvince(obj) {
              
                if(this.addModel){
                

                    this.$refs['citySelect'].$data.query = '';
                    if (this.formData.province_id) {
                        this.formData.province_name=obj.label;
                        this.getCityList(obj.value);
                    } else {
                        this.cityList = [];
                        this.areaList = [];
                        this.formData.province_id='';
                        this.formData.province_name='';
                        this.formData.city_id = '';
                        this.formData.city_name = '';
                        this.formData.area_id = '';
                        this.formData.area_name = '';

                    }
                }else{
                 
                    this.$refs['citySelects'].$data.query = '';
                    if (this.formItem.province_id) {
                        this.getCityList(obj.value);

                        this.formItem.page = 1;
                        this.getData();
                    } else {
                        this.cityList = [];
                        this.areaList = [];
                        this.formItem.province_id='';
                        this.formItem.city_id = '';
                        this.formItem.area_id = '';
                        this.formItem.page = 1;
                        this.getData();
                    }
                }
                
            },
            changeCity(obj){
                if(this.addModel){
                    this.$refs['areaSelect'].$data.query = '';
                    if (this.formData.city_id) {
                        this.formData.city_name=obj.label;
                        this.getAreaList(obj.value);
                    } else {
                        this.areaList = [];
                        this.formData.city_id = '';
                        this.formData.city_name = '';
                        this.formData.area_id = '';
                        this.formData.area_name = '';
                    }
                }else{
                    this.$refs['areaSelects'].$data.query = '';
                    if (this.formItem.city_id) {
                        this.getAreaList(obj.value);

                        this.formItem.page = 1;
                        this.getData();
                    } else {
                        this.areaList = [];
                        this.formItem.city_id = '';
                        this.formItem.area_id = '';
                        this.formItem.page = 1;
                        this.getData();
                    }
                }
                
            },
            changeArea(obj) {
                if(this.addModel){
                    if (this.formData.area_id) {
                        this.formData.area_name=obj.label;
                    } else {
                        this.formData.area_id = '';
                        this.formData.area_name = '';
                    }   
                }else{
                    if (this.formItem.area_id) {
                        this.formItem.page = 1;
                        this.getData();
                    } else {
                        this.formItem.area_id = '';
                        this.formItem.page = 1;
                        this.getData();
                  
                    }   
                }
                
            },
            // 取消关闭弹层
            cancel(){
                this.addModel=false;
                this.schoolModel=false;
            },
            // 关闭提醒弹出
            cancelRemain(){
                this.remindModal = false; 
            },
            //搜索框搜索
            handleSearch () {
                this.formItem.page = 1;
                this.getData();
            },
            //改变当前页码
            changePage (row) {
                this.formItem.page = row;
                this.getData();
            },
            
        },
        created () {
            this.getData();
            this.getProvinceList();
        }
    };
</script>
